import BaseVM from './base-vm';
import Utils from './utils';
import CourseResourceEditViewModel from '../../resource/editor/editor-vm';
var ResourceViewModel = function() { this.init.apply(this, arguments); };
ResourceViewModel.prototype = Kadenze.Util.extendClass(BaseVM, {
  selectedResource: ko.observable(),
  newResource: ko.observable(),
  resourceEditing: ko.observable(false),
  backupResource: ko.observable(),
  resourceTypeMap: {
    BookResource: 'Book',
    LinkResource: 'Webpage',
    DownloadResource: 'File',
    SoftwareResource: 'Product',
    EmbeddedVideoResource: 'Embedded video resource'
  },

  /*---------------------------------------- INITIALIZERS ----------------------------------------------------*/

  init: function(data, wizard) {
    var self = this;

    this.super('init', wizard, data);

    // Filter out already attached existing resources prior to mapping
    data.existing_resources = this.filterOutById(data.resource_ids, data.existing_resources);

    this.mapping = {
      ignore: ['$container'],
      include: ['resources_attributes', 'resource_ids'],

      existing_resources: {
        create: function(options) {
          // Dynamically added property to track selection, bindings will break without this
          options.data.selected = false;

          return options.data;
        }
      },

      resources: {
        create: function(options) {
          var VM = new CourseResourceEditViewModel(_.extend(options.data, { editing: false, _destroy: false }));
          VM.domId(VM.resource() ? ('resource-' + VM.resource().id()) : VM.domId()); //To play nice with sortable
          VM.option_select_text = ko.observable(VM.option_select_text);

          if(options.data.type) {
            VM.resource_type(options.data.type);
            VM.resource_id(options.data.id);
            VM.resource().named_type(options.parent.resourceTypeMap[options.data.type]); // Manually keep the names in sync
          }

          return VM;
        }
      }
    };

    ko.mapping.fromJS(data, this.mapping, this);

    // For the publish panel summary
    this.existingResourcesCount = ko.computed(function() {
      return self.resources().length;
    });

    this.hasResources = ko.computed(function() {
      return !!self.resources().length;
    });

    self.resources().sort(function(a, b) {
      return a.resource().order() - b.resource().order();
    });

  },

  initUI: function() {
    this.initalized = true;
    this.loadExistingResources();
    this.initResourceSorting();
  },

  /*---------------------------------------- UI METHODS ----------------------------------------------------*/

  edit: function (resource, event) {
    Utils.toggleRowVisibility(event);
    this.selectedResource(resource);
  },

  closeEditor: function(item, event) {
    if(this.isSessionResourceValid()) {
      Utils.toggleRowVisibility(event);
      this.selectedResource(null);
      this.newResource(null);
      this.resourceEditing(false);
      this.update(this.wizard.getAllData());
    }
  },

  cancelSessionResource:  function () {
    this.resourceEditing(false);
  },

  reBind: function(session) {
    // Re build resources
    this.resources([]); // clear existing
    this.resource_ids(session.resource_ids); // Sync with server

    // Sync with server
    _.each(_.sortBy(session.resources, 'order'), this.resources.mappedCreate, this);
  },

  initResourceSorting: function() {
    var self = this,
      $el = $('.js-sortable-resources');

    $el.sortable({
      itemSelector: '.display-table__data',
      handle: '.display-table__sort-handle',
      update: function(event, ui) {
        self.onResourceSort($el, event, ui);
      }
    });
  },

  onResourceSort: function($el, event, ui) {
    var request,
      self = this;

    this.cleanUpSorting(ui);
    var rows = $('.js-sortable-resources .display-table__data');
    _.each(rows, function(row, idx){
      var $hidden_ele = $(row).find('.js-res-id');
      $hidden_ele.text(idx+1);
    });

    this.updateResourceOrder();

    request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.sort_course_resources_path(this.data.course_id),
      dataAsJSON: false,
      data: $el.sortable('serialize'),
      loadingIndicator: {
        container: self.getContainer()
      }
    });

    request.fail(function(data) {
      console.log(data);
    });

    request.done(function() {
      new Kadenze.Notice.success({ message: self.successMessage });
    });
  },

  cleanUpSorting: function(ui) {
    //retrieve our actual data item
    var item = ko.dataFor(ui.item[0]);

    //figure out its new position
    var position = ko.utils.arrayIndexOf(ui.item.parent().children(), ui.item[0]);

    //ko rebinds the array so remove duplicate item from the DOM
    ui.item.remove();

    //remove the item and add it back in the right spot
    if (position >= 0) {
      this.resources.remove(item);
      this.resources.splice(position, 0, item);
      this.resource_ids.remove(item.resource_id());
      this.resource_ids.splice(position, 0, item.resource_id());
    }
  },

  updateResourceOrder: function() {
    _.each(this.resources(), function(resvm, index){
      resvm.resource().order(index);
    });
  },

  /*---------------------------------------- CRUD(ish) METHODS ----------------------------------------------------*/

  saveSessionResource: function () {
    if(this.isSessionResourceValid()) {
      if(this.selectedResource().multiResourceSelectionEnabled()) {
        this.save();
      } else {
        this.saveNewSessionResource();
      }
    }
  },

  saveNewSessionResource: function() {
    var res = this.selectedResource().resource();
    res.updated_at(new Date());
    res.status(this.data.status);
    this.resources.mappedCreate(res);
    this.save();
  },

  addResourceToSession() {
    const subdata = ko.mapping.toJS(this.resource_template)
    const resource = new CourseResourceEditViewModel(
        Object.assign({}, subdata, { editing: false, _destroy: false })
    )

    this.newResource(resource)
    this.selectedResource(resource)
    this.resourceEditing(true)
  },

  save: function() {
    this.resourceEditing(false);
    this.createOrUpdate(this.wizard.getAllData());
  },

  delete: function (resource, event) {
    var self = this;

    Kadenze.UIUtil.confirmAction( 'Are you sure you want to remove this resource?', function () {
      resource._destroy(true);
      self.update(self.wizard.getAllData());

      var editor = ko.utils.arrayFirst(self.resources(), function(res) { return res.resource()._destroy() === true; });
      self.resources.remove(editor);
    });
  },

  /*---------------------------------------- DATA PREP ----------------------------------------------------*/

  filterOutById: function(ids, items) {
    return _.filter(items, function(item) {
      return !_.contains(ids, item.id);
    });
  },

  loadExistingResources: function() {
    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      timeout: 50000,
      url: Kadenze.Routes.course_resources_path(this.data.course_id)
    });

    request.done($.proxy(this.bindExistingResources, this));
  },

  bindExistingResources: function(data) {
    this.existing_resources([]); // clear existing

    // Filter attached existing resources prior to mapping
    data.resources = this.filterOutById(this.resource_ids(), data.resources);

    // Sync with server
    _.each(data.resources, this.existing_resources.mappedCreate, this);
  },

  // Minimum requirements to consider this page 'done'
  hasData: function() {
    return !!this.resources().length;
  },

  isSessionResourceValid: function () {
    return !!!this.validateSessionResource().length;
  },

  validateSessionResource: function() {
    var errors = ko.validation.group(this.selectedResource);

    errors.showAllMessages(true);
    return errors();
  },

  getSummary: function() {
    return {
      id: 3, // allow's KO to update items easily
      heading: Kadenze.I18n.t('session.publish_summary.session_resources_label'),
      overviewItems: [
        { title: `${Kadenze.I18n.t('session.publish_summary.resources_attached_label')} :`, description: this.existingResourcesCount }
      ]
    };
  },

  prepareData: function() {
    this.updateResourceOrder();
    var existingResourceIds = _.chain(this.existing_resources())
      .select(function(res) { return res.selected; })
      .map(function(res) { return res.id; })
      .value();

    var cleanResources = _.map(this.resources(), function(res) {
      var resource = ko.toJS(Utils.extractObservables(res.resource()));

      if (resource.info) {
        // Delete this so it's not sent as attributes to the server
        delete resource.info.__ko_mapping__;
      }

      return resource;
    });

      // The server only cares about 'resources_attributes' so tell ko mapping to
      // ignore the others, it's done here so they're only ignored when mapped
      // BACK to js not FROM js.
    this.__ko_mapping__.ignore.push('resources', 'resource_template', 'existing_resources');
    this.resource_ids(_.union(existingResourceIds, this.resource_ids()));
    this.resources_attributes = cleanResources;
  }

});
export default ResourceViewModel;

